import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { getToken, getUser, setUserSession } from "../../Utils/Common";
import { useSelector, useDispatch } from "react-redux";
import { setUserCredits } from "../../features/counter/counterSlice";
import { ResponseMessage } from "../../components/messages/response-message";
import "./takebreak.css";

function Takebreak(props) {
  const [subscription, setSubscription] = useState({});
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const user = getUser();
  const token = getToken();
  const [errorMessage, setErrorMessage] = useState("");
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    is_checked: "30",
  });

  useEffect(() => {
    //Check to see if this is a redirect back from Checkout
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}v1/user/get-subscription`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      // data: {
      //     price: "price_1KhY8bHuNOGPY9jaCIulrQ90",
      // },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data.data);
          setSubscription(response.data.data);
          // setUserSession(token, response.data.user);
          // setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        if (error.response.status === 500) {
          console.log(error.response);
        } else if (error.response.status === 401) {
          console.log(error.response);
        } else if (error.response.status === 404) {
          console.log(error.response.data.message);
          setErrorMessage(error.response.data.message);
        } else {
        }
      });
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  // console.log(state.is_checked);
  const pauseSubscription = (event) => {
    event.preventDefault();
    // console.log("click");

    var formData = new FormData();
    formData.append("interval", parseInt(state.is_checked));

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/pause-subscription/${subscription.id}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: formData,
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response);
          setSubscription(response.data);
          setsucessMessage(response.data.message);
          setStatus(200);
          setMessage(response.data.message);
          // setLoader(false);
          // dispatch(setUserCredits(response.data.user));
          // navigate("/account");

          // setInterval(() => {
          //   /*
          //       Run any function or setState here
          //   */

          // }, 2000);
          navigate("/lingostory");
        }
      })
      .catch((error) => {
        // setLoader(false);
        console.log(error.response);
        if (error.response.status === 422) {
          console.log(error.response);
          setStatus(422);
          setMessage(error.response.data.message);
          // setErrorMessage(error.response.data.message);
        } else if (error.response.status === 401) {
          setStatus(401);
          setMessage(error.response.data.message);

          // setErrorMessage(error.response.data.message);
        } else if (error.response.status === 500) {
          setStatus(500);
          setMessage(error.response.data.message);
          // setErrorMessage(error.response.data.message);
        } else {
          setStatus(500);
          setMessage(error.response.data.message);
          // setErrorMessage("Something went wrong. Please try again later.");
        }
        // if (error.response.status === 500) {
        //   console.log(error.response.data.message);
        //   setErrorMessage(error.response.data.message);
        // } else if (error.response.status === 401) {
        //   console.log(error.response.data.message);
        //   setErrorMessage(error.response.data.message);
        // } else {
        // }
      });
  };

  return (
    <div
      className="d-flex flex-column flex-root"
      style={{ marginTop: "140px" }}
    >
      <div
        className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        style={{
          backgroundImage: "url(assets/media/illustrations/sketchy-1/14.png",
        }}
      >
        <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
          {/* <p style={{ color: "red", fontSize: "20px" }}>{errorMessage}</p> */}
          <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15">
            <form method="POST" onSubmit={pauseSubscription}>
              <div className="text-center mb-10">
                <ResponseMessage status={status} message={message} />
                <p style={{ color: "green", fontSize: "20px" }}>
                  {sucessMessage}
                </p>
                <h1 className="link-primary fw-bolder">
                  Keep your credits and don't make a payment for the next:
                </h1>

                <div className="row mt-18 text-center">
                  {/* <div className="radio-buttons">
                    30 Days
                    <input
                      className="form-check-input"
                      id="windows"
                      value="30"
                      name="platform"
                      type="radio"
                      onChange={handleChange}
                      {...(state.is_checked === "30" ? "checked" : "")}sss
                    />
                    60 Days
                    <input
                      id="mac"
                      value="60"
                      name="platform"
                      type="radio"
                      onChange={handleChange}
                    />
                    90 Days
                    <input
                      id="linux"
                      value="90"
                      name="platform"
                      type="radio"
                      onChange={handleChange}
                    />
                  </div> */}
                  <div className="form-check-custom form-check-solid">
                    {/* <form> */}
                    <input
                      className="form-check-input"
                      type="radio"
                      // value={90}
                      value="30"
                      name="is_checked"
                      id="is_checked"
                      onChange={handleChange}
                      // checked
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault"
                    >
                      30 days
                    </label>

                    <input
                      className="form-check-input"
                      type="radio"
                      // value={60}
                      value="60"
                      name="is_checked"
                      id="is_checked"
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault"
                    >
                      60 days
                    </label>

                    <input
                      className="form-check-input"
                      type="radio"
                      // value={30}
                      value="90"
                      name="is_checked"
                      id="is_checked"
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault"
                    >
                      90 days
                    </label>
                    {/* </form> */}
                  </div>
                </div>
              </div>

              <div className="fv-row mb-10">
                <div className="d-flex flex-stack mb-2">{/*end::Link*/}</div>
                {/*end::Wrapper*/}
                {/*begin::Input*/}

                {/*end::Input*/}
              </div>
              {/*end::Input group*/}
              {/*begin::Actions*/}
              <div className="text-center">
                {/*begin::Submit button*/}
                <div className="col-12">
                  <button
                    className="btn btn-lg btn-dark w-200px mb-5"
                    // onClick={makeTran}
                  >
                    <span className="indicator-label">Pause Membership</span>
                  </button>
                </div>
                <div className="col-12">
                  {/* <button
                  className="btn btn-outline-dark mb-5"
                  style={{ border: "2px solid #000" }}
                  // onClick={makeTran}
                >
                  <span className="indicator-label">Cancel Anyway</span>
                </button> */}

                  <Link
                    className="btn btn-outline-dark m-0"
                    to={`/account/cancellation/reason`}
                    style={{ border: "2px solid #000" }}
                  >
                    Cancel Anyway
                  </Link>
                </div>

                {/*end::Separator*/}
              </div>
              {/*end::Actions*/}

              {/*end::Form*/}
            </form>
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Content*/}
        {/*begin::Footer*/}
        <div className="d-flex flex-center flex-column-auto p-10">
          {/*begin::Links*/}
          <div className="d-flex align-items-center fw-bold fs-6">
            <a href="/#" className="text-muted text-hover-primary px-2">
              About
            </a>
            <a href="/#" className="text-muted text-hover-primary px-2">
              Contact
            </a>
            <a href="/#" className="text-muted text-hover-primary px-2">
              Contact Us
            </a>
          </div>
          {/*end::Links*/}
        </div>
        {/*end::Footer*/}
      </div>
      {/*end::Authentication - Sign-in*/}
    </div>
  );
}

export default Takebreak;
